const axios = require("axios");

export default class RDService {
  sendConversion(email, score, externalId) {
    var config = {
      method: "post",
      url: process.env.VUE_APP_API + "/rd/conversion",
      headers: {
        "Content-Type": "application/json",
      },
      data: { email, score, externalId },
    };

    return axios(config);
  }
}
